export const boardFormTour = {
  key: "boardForm",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-form-create"]',
      content: t("Tour_BoardForm_Create"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-form-fields"]',
      content: t("Tour_BoardForm_Fields"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-form-share"]',
      content: t("Tour_BoardForm_Share"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-form-submissions"]',
      content: t("Tour_BoardForm_Submissions"),
      placement: "top",
    },
  ],
};
